import { JsonObject, JsonProperty } from 'typescript-json-serializer';

@JsonObject()
export class CarId {
  @JsonProperty('Identification') identification: string;
  @JsonProperty('UserId') userId: string;
  @JsonProperty('ValidUntil') validUntil: Date;
  @JsonProperty('Name') name: string;

  constructor(
    identification: string,
    userId: string,
    validUntil: Date,
    name: string
  ) {
    this.identification = identification;
    this.userId = userId;
    this.validUntil = validUntil;
    this.name = name;
  }
}
